<template>
  <div>
    <div
      v-for="(item, index) in profileMenus"
      :key="index"
    >
      <v-list-item
        v-if="item.guards.filter(guard => guard === false).length === 0"
        :href="item.href"
        @click="handleClick(item)"
        :disabled="item.disabled"
        :target="item.target"
        rel="noopener">
        <v-list-item-action v-if="item.icon">
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </div>
  </div>
</template>

<script>
import guardsMixin from '@/mixins/guards'
import {RoleGroups} from '@/util/constants'

const {
  PRINCIPAL_OWNER_ROLE_IDS,
  SALES_MANAGER_ROLE_IDS
} = RoleGroups

export default {
  mixins: [guardsMixin],
  methods: {
    handleClick(item) {
      typeof item.click === `function` ? item.click() : () => {}
      this.$emit('close')
    },
    async handleLogout() {
      await this.$store.dispatch('logout')
    },
    async confirmLogout() {
      window._VMA.$emit('CONFIRM', {
        title: `Confirm Logout`,
        message: `Are you sure you want to logout?`,
        options: {},
        callback: (agree) => {
          if (agree) this.handleLogout()
        },
      })
    }
  },
  computed: {
    profileMenus() {
      return [
        {
          icon: 'mdi-cog',
          title: 'General Settings',
          href: '/#/user/settings',
          guards: [this.fullAccessCompanyOnly()]
        },
        {
          icon: 'mdi-account-multiple',
          title: 'Users/Roles',
          href: '/#/company/users',
          guards: [this.fullAccessCompanyOnly(), this.permissionsByRoleOnly(PRINCIPAL_OWNER_ROLE_IDS.concat(SALES_MANAGER_ROLE_IDS))]
        },
        {
          icon: 'mdi-map',
          title: 'Address Book',
          href: '/#/addresses',
          guards: [this.fullAccessCompanyOnly()]
        },
        {
          icon: 'mdi-bank',
          title: 'Bank Info',
          href: '/#/bank-info',
          guards: [this.isAccounting(), this.fullAccessCompanyOnly()]
        },
        {
          icon: 'mdi-power',
          href: '#',
          title: 'Logout',
          click: this.confirmLogout,
          guards: []
        }
      ]
    }
  }
}
</script>
